<template>
  <pbc-modal ref='modal' @close="$emit('close')" title="Settings">
    <template #default="{}">
      <div class="flex flex-col items-center">
        <div class="flex flex-row m-2">
          <numberer class="w-64 flex-none" v-model='gamedata.game.cols' :step='1' />
          <div class="text-black font-bold ml-4">Cols</div>
        </div>
        <div class="flex flex-row m-2">
          <numberer class="w-64 flex-none" v-model='gamedata.game.rows' :step='1' />
          <div class="text-black font-bold ml-4">Row</div>
        </div>
      </div>
    </template>
    <template #controls='{}'>
      <div class="mx-2 mb-2 pt-2 flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click="$emit('close')">
          <check class="mx-1"/>
          <span class="mr-2">Done</span>
        </pbc-button>
      </div>
    </template>

  </pbc-modal>
</template>
<script>
export default {
  props:{
    gamedata:{
      type:Object,
      required:true
    }
  }
}
</script>
